import type {CSSProperties, ReactNode} from 'react';

const EMPTY_STATE_STYLE: CSSProperties = {
  textAlign: 'center',
  padding: '3rem',
  color: 'var(--ink-faint)',
  fontSize: 13,
};

// `loading` and `loadError` are gates, not data: the component only ever tests
// them for truthiness. `loadError` is deliberately `unknown` because every
// operational list passes its notice OBJECT ({kind, message} | null) here, not a
// boolean, even though the default below is `false`.
type OperationalListEmptyStateProps = {
  loading?: unknown;
  loadError?: unknown;
  totalCount: number;
  filteredCount: number;
  emptyLabel: ReactNode;
  filteredLabel?: ReactNode;
  'data-empty-state'?: string;
};

export default function OperationalListEmptyState({
  loading = false,
  loadError = false,
  totalCount,
  filteredCount,
  emptyLabel,
  filteredLabel = 'No records match the current filters',
  'data-empty-state': dataEmptyState,
}: OperationalListEmptyStateProps) {
  if (loading || loadError || filteredCount > 0) return null;
  const label = totalCount === 0 ? emptyLabel : filteredLabel;
  return (
    <div
      data-empty-state={dataEmptyState || (totalCount === 0 ? 'true-empty' : 'filtered-empty')}
      style={EMPTY_STATE_STYLE}
    >
      {label}
    </div>
  );
}
